/**
 * eCommerce PO-number requirement (create-time).
 *
 * Only rendered when the selected distributor supports the capability
 * (`supplier.metaData.allowEcommercePoNumber`). For distributors without it the
 * section is hidden entirely — the capability must be enabled in the
 * distributor's settings first (legacy parity, #125 acceptance: unsupported
 * controls are hidden).
 */

import type { CreateChatFormData } from '@choco-admin/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ChocoCheckbox } from '../../../../../../components/FormComponents';

export const EcommercePoNumberSection: React.FC = () => {
  const { control, watch } = useFormContext<CreateChatFormData>();

  const distributorSupportsPoNumber = Boolean(
    watch('supplier')?.metaData?.allowEcommercePoNumber
  );

  if (!distributorSupportsPoNumber) {
    return null;
  }

  return (
    <div className="space-y-2" data-testid="EcommercePoNumberSection">
      <h4 className="font-medium text-foreground">Ordering</h4>
      <Controller
        name="isEcommercePoNumberRequired"
        control={control}
        render={({ field }) => (
          <ChocoCheckbox
            id="isEcommercePoNumberRequired"
            isSelected={field.value || false}
            onValueChange={field.onChange}
            size="sm"
            label="Require an eCommerce PO number"
            description="Buyers must enter a purchase-order number to place an order in eCommerce for this chat."
          />
        )}
      />
    </div>
  );
};
